import { render } from "./BlackBanner.vue?vue&type=template&id=528feb8f&scoped=true"
import script from "./BlackBanner.vue?vue&type=script&lang=js"
export * from "./BlackBanner.vue?vue&type=script&lang=js"

import "./BlackBanner.vue?vue&type=style&index=0&id=528feb8f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528feb8f"]])

export default __exports__